import { AlertTriangle, X } from 'lucide-react'
import { useThemeOrchestratorStore } from '@/stores/themeOrchestratorStore'

export function SurvivalModeIndicator() {
  const activeOverlay = useThemeOrchestratorStore((s) => s.activeOverlay)
  const dismissSurvival = useThemeOrchestratorStore((s) => s.dismissSurvival)

  if (activeOverlay !== 'survival') return null

  return (
    <div className="bg-surface-tertiary border-b border-base px-4 py-2 flex items-center justify-between animate-in slide-in-from-top-2">
      <div className="flex items-center gap-2 text-sm">
        <AlertTriangle className="w-4 h-4 text-caption" />
        <span className="text-body">
          <span className="font-medium text-heading">서바이벌 모드</span> — 기한 초과 작업이 많습니다. 하나씩 처리해보세요.
        </span>
      </div>
      <button
        type="button"
        onClick={dismissSurvival}
        className="p-1 rounded-lg hover-surface text-caption"
        aria-label="서바이벌 모드 해제"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  )
}
